import { PortalPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';
import React, { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface DisputeStatusToolTipProps {
  InfoIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }> | null;
  InfoText: string;
  handleShowToolTip: VoidFn;
  handleCloseToolTip: VoidFn;
  showToolTip: boolean;
  widthStyle?: string;
}

const DisputeStatusToolTip: FC<DisputeStatusToolTipProps> = ({
  InfoIcon,
  InfoText,
  handleCloseToolTip,
  handleShowToolTip,
  showToolTip,
  widthStyle = 'w-[270px]'
}) => {
  if (!InfoIcon) {
    return null;
  }

  const anchorComponent = () => (
    <div onMouseEnter={handleShowToolTip} onMouseLeave={handleCloseToolTip} className="cursor-pointer">
      <InfoIcon className="shrink-0" />
    </div>
  );

  return (
    <PortalPopover
      show={showToolTip}
      onTogglePopover={handleShowToolTip}
      onClosePopover={handleCloseToolTip}
      anchorComponent={anchorComponent}
      highlightAnchor={false}
      offset={{ top: 32, left: -135 }}
      width={widthStyle}
      padding="p-4"
      showArrow
      arrowType={PopoverArrowTypes.TOP}
      arrowOffset="left-1/2 -translate-x-1/2"
      arrowClassName="border-l border-t border-borderGray bg-primary"
      containerClassName="border border-borderGray bg-primary shadow-[0px_20px_60px_rgba(9,26,70,0.1)]">
      <div className="text-px13 font-normal text-primaryText">{InfoText}</div>
    </PortalPopover>
  );
};

export default DisputeStatusToolTip;
